import React, { useEffect, useState } from "react";
import { api, V1 } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Layers, Plus, Trash2, Pencil } from "lucide-react";
import { toast } from "sonner";

const EMPTY = { name: "", from_count: 1, to_count: 100, price_per_app: 5, sort: 0 };

export default function AdminApplicationTiers() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get(`${V1}/application-tiers`).then((r) => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const save = async () => {
    const payload = { ...form, from_count: parseInt(form.from_count), to_count: parseInt(form.to_count), price_per_app: parseFloat(form.price_per_app), sort: parseInt(form.sort || 0) };
    try {
      if (editing) await api.patch(`${V1}/admin/application-tiers/${editing.id}`, payload);
      else await api.post(`${V1}/admin/application-tiers`, payload);
      toast.success("Kaydedildi");
      setOpen(false); setEditing(null); setForm(EMPTY); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Hata"); }
  };

  const remove = async (id) => {
    if (!window.confirm("Fiyat basamağı silinsin mi?")) return;
    await api.delete(`${V1}/admin/application-tiers/${id}`); load();
  };

  const openEdit = (t) => { setEditing(t); setForm({ name: t.name, from_count: t.from_count, to_count: t.to_count, price_per_app: t.price_per_app, sort: t.sort }); setOpen(true); };

  return (
    <div className="space-y-6" data-testid="admin-app-tiers-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div>
          <div className="overline text-accent">Ticaret</div>
          <h1 className="font-display text-3xl font-bold flex items-center gap-2"><Layers className="h-7 w-7 text-primary" /> Başvuru Başına Fiyatlandırma</h1>
          <p className="text-muted-foreground text-sm mt-1">Okulun aldığı başvuru sayısına göre kademeli fiyat.</p>
        </div>
        <Button onClick={() => { setEditing(null); setForm(EMPTY); setOpen(true); }} data-testid="new-tier-btn"><Plus className="h-4 w-4" /> Yeni Basamak</Button>
      </div>

      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-xs uppercase tracking-widest text-muted-foreground">
            <tr><th className="text-left p-3">Sıra</th><th className="text-left p-3">Ad</th><th className="text-left p-3">Aralık</th><th className="text-left p-3">Başvuru Başına</th><th></th></tr>
          </thead>
          <tbody>
            {items.map((t) => (
              <tr key={t.id} className="border-t border-border" data-testid={`tier-${t.id}`}>
                <td className="p-3">{t.sort}</td>
                <td className="p-3 font-medium">{t.name}</td>
                <td className="p-3">{t.from_count} - {t.to_count > 0 ? t.to_count : "∞"}</td>
                <td className="p-3 font-bold">₺{t.price_per_app}</td>
                <td className="p-3 text-right space-x-1">
                  <Button size="sm" variant="ghost" onClick={() => openEdit(t)} data-testid={`edit-tier-${t.id}`}><Pencil className="h-3.5 w-3.5" /></Button>
                  <Button size="sm" variant="ghost" onClick={() => remove(t.id)} data-testid={`del-tier-${t.id}`}><Trash2 className="h-3.5 w-3.5 text-destructive" /></Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent><DialogHeader><DialogTitle>{editing ? "Basamağı Düzenle" : "Yeni Basamak"}</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Ad</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="tier-name" /></div>
            <div className="grid grid-cols-2 gap-2">
              <div><Label>Alt Sınır</Label><Input type="number" value={form.from_count} onChange={(e) => setForm({ ...form, from_count: e.target.value })} data-testid="tier-from" /></div>
              <div><Label>Üst Sınır (0=∞)</Label><Input type="number" value={form.to_count} onChange={(e) => setForm({ ...form, to_count: e.target.value })} data-testid="tier-to" /></div>
            </div>
            <div><Label>Başvuru Başına Ücret (₺)</Label><Input type="number" step="0.5" value={form.price_per_app} onChange={(e) => setForm({ ...form, price_per_app: e.target.value })} data-testid="tier-price" /></div>
            <div><Label>Sıra</Label><Input type="number" value={form.sort} onChange={(e) => setForm({ ...form, sort: e.target.value })} /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Vazgeç</Button>
            <Button onClick={save} disabled={!form.name} data-testid="save-tier-btn">Kaydet</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
